<template>
  <div >
    <v-layout class="rounded rounded-md" >
        <v-navigation-drawer v-if="navBar&&store.state.user.token" >

          
          <Recherche></Recherche>
      </v-navigation-drawer>
      <v-app-bar v-if="store.state.user.token">
        <v-btn icon="$vuetify" @click="navBar=!navBar"></v-btn>
        <v-tabs
          >
            <v-tab v-if="['D'].find(el=>el==store.state.user.groupe)" text="Edisac" value="Edisac" @click="goTo('/edisac')"></v-tab>
            <v-tab v-if="['A','B'].find(el=>el==store.state.user.groupe)" text="Fripe" value="Fripe" @click="goTo('/fripe')"></v-tab>
            <v-tab v-if="['A','B','C','D'].find(el=>el==store.state.user.groupe)" text="Reception" value="Reception" @click="goTo('/reception')"></v-tab>
            <v-tab v-if="['A','B','D'].find(el=>el==store.state.user.groupe)" text="Validation" value="Validation" @click="goTo('/validation')"></v-tab>
            <v-tab v-if="['A','N'].find(el=>el==store.state.user.groupe)" text="Negoce" value="Negoce" @click="goTo('/negoce')"></v-tab>
            <v-tab v-if="['A'].find(el=>el==store.state.user.groupe)" text="Frep" value="Frep" @click="goTo('/frep')"></v-tab>
            <v-tab v-if="['A'].find(el=>el==store.state.user.groupe)" text="Import" value="Import" @click="goTo('/import')"></v-tab>
            <v-tab v-if="['A'].find(el=>el==store.state.user.groupe)" text="Importxt" value="Importxt" @click="goTo('/importxt')"></v-tab>
            <v-tab v-if="['A','B'].find(el=>el==store.state.user.groupe)" text="Achat" value="achat" @click="goTo('/achat')"></v-tab>
            <v-tab v-if="['A','B'].find(el=>el==store.state.user.groupe)" text="CRM" value="Stats" @click="goTo('/crm')"></v-tab>
            <!-- <v-tab v-if="['A'].find(el=>el==store.state.user.groupe)" text="Table" value="Table" @click="goTo('/table')"></v-tab> -->
          </v-tabs>
          <!-- <JsonToExcel></JsonToExcel> -->
          <!-- <v-btn v-if="['A','B'].find(el=>el==store.state.user.groupe)" @click="exportToExcel()" color="success" ><v-icon icon="mdi-file-excel"></v-icon></v-btn>  -->
          <logout-button/>
          
      </v-app-bar>
      <v-main class="d-flex align-center justify-center" style="min-height: 300px;">
        <RouterView/>
      </v-main>
  </v-layout>
  </div>
</template>
<script setup>
import Recherche from './Recherche.vue';
import axios from 'axios'
import {onBeforeMount, onMounted, onUpdated, ref} from 'vue'
import store from './store'
import router from './router'
import * as XLSX from 'xlsx';
import LogoutButton from '@/components/LogoutButton.vue'
let navBar=ref(false)
// let groupe=ref(['A','',''])
const handleBeforeLogout = async () => {
  // console.log('Déconnexion en cours...')
  // Sauvegarder des données si nécessaire
}

const handleAfterLogout = async () => {
  // console.log('Déconnecté avec succès')
  // Notification ou autre action
}
const goTo=(link)=>{
  store.commit('updateComponent',router.currentRoute.value.name)
  router.replace({ path: link }) 
}
const getArticles=()=>{     
  // store.commit('updateWaiting')  
    let config = {
    method: 'get',
    url: 'https://my.edisac.com/api/theme'
    };
    return   axios.request(config)
    .then((response) => {
      store.commit('addArticles',response.data)    
      // store.commit('updateWaiting')     
    })
    .catch((error) => {
    // store.commit('updateWaiting')
    // console.log(error);
    });
  }
    const exportToExcel = () => {
      // const flatData = flattenArticles(fabricant);
      // console.log(store.state.listeReceptions.data);
      const worksheet = XLSX.utils.json_to_sheet(store.state.listeReceptions.data.map(el=>el={...el,annee:(new Date(el.date)).getFullYear(),mois:(new Date(el.date)).toLocaleString('fr-FR', { month: 'long' }),mois_annee:`${(new Date(el.date)).toLocaleString('fr-FR', { month: 'long' })}_${(new Date(el.date)).getFullYear()}`}));
      
      
      const workbook = XLSX.utils.book_new();
      
      XLSX.utils.book_append_sheet(workbook, worksheet, `EXPORT_FRIPE`);

      // Télécharger le fichier
      XLSX.writeFile(workbook, `export_secondLife_${getCurrentDateYYYYMMDD()}.xlsx`);
    };
    function getCurrentDateYYYYMMDD() {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Mois commence à 0
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}${month}${day}`;
    }

  const getRecherche=()=>{
        let themes=[]
        let config = {
        method: 'get',
        url: 'https://my.edisac.com/api/recherche'
        };
        return   axios.request(config)
        .then((response) => {   
        store.commit('addmarques',Object.keys(response.data).map((x) => x +" - " +response.data[x][Object.keys(response.data[x])[0]].marque));
        themes.value=[]
        for (const keys in response.data) {
            for (const key in response.data[keys]) {

              themes.push([key] +' - '+ response.data[keys][key].theme +' | '+  keys)
            }
        }
        store.commit('addThemes',themes)  
        store.commit('updateWaiting') 
        })
        .catch((error) => {
        //console.log(error);
        });
    }
    
    const getClassification=()=>{
      let rayons=[]
      let familles=[]
      let sousFamilles=[]
        let config = {
        method: 'get',
        url: 'https://my.edisac.com/api/classification'
        };
        return   axios.request(config)
        .then((response) => {
            // console.log( 'fetching classes'); 
            for (const mar in response.data) {
              for (const ray in response.data[mar]) {
                rayons.push([mar] +'|'+ [ray])
                for (const fam in response.data[mar][ray]) {
                  familles.push([mar] +'|'+ [ray]+'|'+[fam])
                  for (const sfam in response.data[mar][ray][fam]) {
                    sousFamilles.push([mar] +'|'+ [ray]+'|'+[fam]+'|'+[sfam])
                  }
                }
              }
            }
            store.commit('addRayons',rayons)
            store.commit('addFamilles',familles)
            store.commit('addSousFamilles',sousFamilles)
        })
    }
    async function getClassifications () {
        let config = {
        method: 'get',
        url: 'https://my.edisac.com/api/classifications'
        };
        return   axios.request(config)
        .then((response) => {
          store.commit('addThemes',response.data.recherche.themesList) 
          store.commit('addmarques',response.data.recherche.marquesList) //Object.keys(response.data).map((x) => x +" - " +response.data[x][Object.keys(response.data[x])[0]].marque));
          store.commit('addRayons',response.data.classification.lists.rayons)
          store.commit('addFamilles',response.data.classification.lists.familles)
          store.commit('addSousFamilles',response.data.classification.lists.sousFamilles)
          store.commit('updateWaiting') 
        }
    )}
    async function getTokenY2 () {
      let data = {
        client_id: 'CegidRetailResourceFlowClient',
        username: 'DEVELOPPEUR@98661025_001_PROD',
        password: '!UiP73h',
        grant_type: 'password',
        scope: 'RetailBackendApi offline_access' 
      };

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://retail-services.cegid.cloud/p/as/connect/token',
        headers: { 
          'Content-Type': 'application/x-www-form-urlencoded', 
        },
        data : data
      };

      axios.request(config)
      .then((response) => {
        store.commit('setTokenY2',response.data.access_token)
      })
      .catch((error) => {
        //console.log(error);
      });

    }

    const waiting=()=>{
      store.commit('updateWaiting') 
    }

    const sendGlobalID=()=>{
    let data = {countId:store.state.countId}
    // console.log(data);
    
    let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: 'https://my.edisac.com/api/getID',
    headers: { 
        'Content-Type': 'application/json'
    },
    data : data
    }
    return axios.request(config)
    .then((response) => { 
        // console.log(response);
        
    })
    .catch((error) => {
    //console.log(error);
    });
  }

    // let pdfOptions =ref({
    //         margin: 15,
    //         image: {
    //             type: 'jpeg',
    //             quality: 1,
    //         },
    //         html2canvas: { scale: 3 },
    //         jsPDF: {
    //             unit: 'mm',
    //             format: 'a4',
    //             orientation: 'p',
    //         },
    //     }) 
    // let exportFilename=ref('my-custom-file.pdf') 
    // const pdf = HtmlToPdf
    // const download = () => {
    //     //console.log(HtmlToPdf);
        
    // // HtmlToPdf.value.download()
    // }
    

  onBeforeMount(()=>{
    waiting()
  })
  onMounted(() => {
    // getRecherche()
    getClassifications()
    getTokenY2 ()
  })

</script>